import { STICKERS } from './stickers.data';
import { eraOf } from './years';

export type Sticker = { id: string; name: string; years: [number, number]; svg: string };
export { STICKERS };

function rng(seed: number) { return () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }

/** Stickers that belong to a year (one year either side), topped up from its era, in a stable order. */
export function stickersFor(year: number, count = 8): Sticker[] {
  const era = eraOf(year);
  let list = STICKERS.filter(s => year >= s.years[0] - 1 && year <= s.years[1] + 1);
  if (list.length < count) list = list.concat(STICKERS.filter(s => !list.includes(s) && s.years[0] <= era.to && s.years[1] >= era.from));
  const r = rng(year * 97 + 13);
  return list.map(s => [r(), s] as const).sort((a, b) => a[0] - b[0]).map(x => x[1]).slice(0, count);
}
export const stickerYears = (s: Sticker): string => (s.years[0] === s.years[1] ? `About ${s.years[0]}` : `About ${s.years[0]} to ${s.years[1]}`);
